import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { IRequestEmitirSegundaViaPlaca, Types } from './types';

// ACTIONS
import {
	emitirSegundaViaPlacaSuccess,
	emitirSegundaViaPlacaFailure,
} from './actions';

function* emitirSegundaViaPlacaRequest(request: ReducerAction) {
	const { payload }: { payload: IRequestEmitirSegundaViaPlaca } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/emissao/segundas-vias-placas`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(emitirSegundaViaPlacaSuccess(response.data));
	} else if (response.error) {
		yield put(emitirSegundaViaPlacaFailure());
	}
}

export default all([
	takeLatest(
		Types.EMITIR_SEGUNDA_VIA_PLACA_REQUEST,
		emitirSegundaViaPlacaRequest,
	),
]);
